<template>
  <div>

    <ImagenesTable
      :onlyView="onlyView"
      :imagenesList="imagenesList"
    />
  </div>
</template>

<script>

import ImagenesTable from './ImagenesTable.vue';

export default {
  name: 'ImagenesList',

  props: {
    value: {
      type: Array,
      required: true
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      imagenesList: this.value
    }
  },

  components: {
    ImagenesTable
  }
}
</script>
